import { rem } from "@certn/cascadia";
import { BrandAsset, GridItem, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { ReactNode } from "react";

interface Props {
  title: string;
  subtitle: ReactNode | string;
}

export function AuthHeader(props: Props) {
  const { title, subtitle } = props;

  return (
    <GridItem alignItems="center">
      <BrandAsset width={44} height={44} brand="certn" type="logo" />
      <Text
        style="form/page-title"
        align="center"
        className={css({ marginTop: rem("space-6") })}
      >
        {title}
      </Text>
      <Text
        style="form/body-primary"
        align="center"
        className={css({ marginTop: rem("space-2") })}
      >
        {subtitle}
      </Text>
    </GridItem>
  );
}
